export default class TreeMenuRequest
{
    constructor(
    ) {
    }
}
